import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";

import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import Stats from "./components/site/Stats";
import TrustBar from "./components/site/TrustBar";
import About from "./components/site/About";
import Products from "./components/site/Products";
import Process from "./components/site/Process";
import Industries from "./components/site/Industries";
import WhyUs from "./components/site/WhyUs";
import Quality from "./components/site/Quality";
import Sustainability from "./components/site/Sustainability";
import ServiceAreas from "./components/site/ServiceAreas";
import Testimonials from "./components/site/Testimonials";
import FAQ from "./components/site/FAQ";
import CTABand from "./components/site/CTABand";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";
import WhatsAppFab from "./components/site/WhatsAppFab";
import QuoteDialog from "./components/site/QuoteDialog";
import ProductDialog from "./components/site/ProductDialog";
import SeoJsonLd from "./components/site/SeoJsonLd";

const Home = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [presetProduct, setPresetProduct] = useState("");
  const [activeProduct, setActiveProduct] = useState(null);

  const openQuote = (productName = "") => {
    setPresetProduct(productName || "");
    setQuoteOpen(true);
  };

  return (
    <div className="App">
      <SeoJsonLd />
      <Header onQuote={() => openQuote()} />
      <Hero onQuote={() => openQuote()} />
      <Stats />
      <TrustBar />
      <About />
      <Products onQuote={openQuote} onSelect={setActiveProduct} />
      <Process />
      <Industries />
      <WhyUs />
      <Quality />
      <Sustainability />
      <ServiceAreas />
      <Testimonials />
      <CTABand onQuote={() => openQuote()} />
      <FAQ />
      <Contact />
      <Footer />
      <WhatsAppFab />

      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} presetProduct={presetProduct} />
      <ProductDialog product={activeProduct} onClose={() => setActiveProduct(null)} onQuote={openQuote} />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
